export enum RequestState {
  NOT_REQUESTED = 'NOT_REQUESTED',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
}
